module.exports = __webpack_public_path__ + "img/photo-9.ff99270f.jpg";